export const DEFAULT_PER_PAGE = 50;
export const DEFAULT_PER_PAGE_STORAGE_KEY = undefined; //"getregistered-grid-per-page";
